import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";
import { Filtration } from "../views/filtration/view";
import { FiltrationDetails } from "../views/filtration/view/details";
import Error404 from "../views/404";
import { Discern } from "@/views/discern/view";
import { DiscernDetails } from "@/views/discern/view/details";
import { FinishDiscern } from "@/views/finishDiscern/view";
import { FinishDiscernDetails } from "@/views/finishDiscern/view/details";
import { KeyWords } from "@/views/keyWords/view";
import { WebSite } from "@/views/webSite/view";

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="1" component={Home} />
            <Route exact={true} path={"/filtration"} key="2" component={Filtration} />
            <Route exact={true} path={"/filtration/detail"} key="2-1" component={FiltrationDetails} />
            <Route exact={true} path={"/discern/unfinish"} key="3-1" component={Discern} />
            <Route exact={true} path={"/discern/unfinish/detail"} key="3-1-1" component={DiscernDetails} />
            <Route exact={true} path={"/discern/finish"} key="3-2" component={FinishDiscern} />
            <Route exact={true} path={"/discern/finish/detail"} key="3-2-1" component={FinishDiscernDetails} />
            <Route exact={true} path={"/keyWords"} key="4" component={KeyWords} />
            <Route exact={true} path={"/webSite"} key="5" component={WebSite} />
            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute;